import { render } from "./stage3.vue?vue&type=template&id=2921b7f4&scoped=true"
import script from "./stage3.vue?vue&type=script&lang=js"
export * from "./stage3.vue?vue&type=script&lang=js"

import "./stage3.vue?vue&type=style&index=0&id=2921b7f4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2921b7f4"]])

export default __exports__